<template>
  <index></index>
</template>

<script>
import { defineComponent} from 'vue'
import index from "./components/index.vue"

export default defineComponent({
  name: "App",
  components: {
    index,
  },
})
</script>
